import React, { useState, useCallback } from "react";
import { Plus, RefreshCw, Upload } from "lucide-react";
import uploadService from "../../services/uploadService";
import ImportModal from "../../components/shared/ImportModal";
import FooterBar from "../../components/shared/FooterBar";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../components/Admin/Layout/AdminLayout";
import UserListView from "../../components/Admin/UserManagement/UserListView";

export default function UserManagementPage() {
  const navigate = useNavigate();
  const [componentActions, setComponentActions] = useState(null);
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [pagination, setPagination] = useState({ totalPages: 1, currentPage: 1, totalItems: 0, pageSize: 10, setCurrentPage: null });

  const handleActionsReady = useCallback((actions) => {
    setComponentActions(actions);
  }, []);

  const handlePaginationChange = useCallback((data) => {
    setPagination(data);
  }, []);

  return (
    <AdminLayout>
      <div className="min-h-full flex flex-col">
        {/* Header */}
        <div className="bg-white border-b border-[#D5D9D9] px-4 sm:px-6 py-2 flex items-center justify-between sticky top-0 z-10">
          <h1 className="text-[14px] font-bold text-[#0F1111]">
            Users {pagination.totalItems > 0 && <span className="font-normal text-[#565959]">({pagination.totalItems})</span>}
          </h1>

          <div className="flex items-center gap-1.5 sm:gap-2">
            <button
              onClick={componentActions?.onRefresh}
              className="p-1.5 rounded bg-white border border-[#D5D9D9] text-[#565959] hover:bg-[#F7F7F7] transition-colors"
              title="Refresh"
            >
              <RefreshCw size={14} />
            </button>

            <button
              onClick={() => setImportModalOpen(true)}
              className="px-2.5 py-1.5 bg-white text-[#C45500] border border-[#FFD89E] rounded hover:bg-[#FFF4E6] flex items-center gap-1.5 text-[12px] font-medium transition-colors"
              title="Import Users"
            >
              <Upload size={13} />
              <span className="hidden sm:inline">Import Users</span>
            </button>

            <button
              onClick={() => navigate("/users/add")}
              className="px-2.5 sm:px-3 py-1.5 bg-gradient-to-b from-[#f7ca00] to-[#f0c14b] border border-[#a88734] text-[#0F1111] rounded hover:from-[#f0c14b] hover:to-[#e7ae00] flex items-center gap-1.5 text-[12px] font-semibold shadow-sm transition-all"
            >
              <Plus size={13} />
              <span className="hidden sm:inline">Add User</span>
            </button>
          </div>
        </div>

        {/* User Table */}
        <div className="flex-1 px-3 sm:px-5 py-4">
          <UserListView renderActions={handleActionsReady} onPaginationChange={handlePaginationChange} />
        </div>

        {/* Footer */}
        <FooterBar
          totalPages={pagination.totalPages}
          currentPage={pagination.currentPage}
          onPageChange={(p) => pagination.setCurrentPage?.(p)}
          totalItems={pagination.totalItems}
          pageSize={pagination.pageSize}
        />
      </div>

      <ImportModal
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        onImport={(file) => uploadService.bulkUploadUsers(file)}
        onSuccess={componentActions?.onRefresh}
        title="Import Users"
      />
    </AdminLayout>
  );
}
